import React, { useState, useEffect } from 'react';
import { LeadsModel } from '../models/LeadsModel'
import { RenewalsModel } from '../models/RenewalsModel'
import { LeadsPageModel, SPLeadModel, LeadModel, RenewalsFilterModel, SelectListItem, RiderLeadModel, RiderModel } from '../models/superbit-api-models'
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import { SimulatorModel, SimulatorData } from '../models/SimulatorModel';
import { GeneralDataModel } from '../models/GeneralDataModel';
// import {SuperBit_swaggerClient} from './models/superbit-api-models'
// import { StatOptions } from 'fs';
import { Renewal } from './_Renewal'
//import { RiderRenewal } from './renwals/_RiderRenewal'
import RenewalUpdatePrice from './_renewalUpdatePrice'
import LeadPopup from '../leads/_LeadPopup'
import { LeadAdvancedSearch } from '../leads/_LeadAdvancedSearch'
import { Menu } from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'
import '../assets/css/leads_p0001.css?a=111'
import '../assets/css/leads.css'
import '../assets/css/_simple-popup.css'
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
// import TreeSelect from './components/_TreeSelect';
import Pagger from '../components/_Pagger';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import moment from 'moment';
import generalSettings from '../json/general-settings.json';
import { Select, TreeSelect } from 'antd';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import { connect, useSelector } from 'react-redux';
import LoginPopup from '../login/_LoginPopUp';
import LoginStatus from '../login/_LoginStatus';
import { LoginModel } from '../models/LoginModel';
import GoToLogin from '../login/_goToLogin';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import StationUserSelect from '../components/_StationUserSelect';
import { setBranchesData, setIdForLeadPopup } from '../app-context/policyProduction';
import { RootState } from '../app-context/store';
import LeadOfferProduction from '../leads/_LeadOfferProduction';
import CustomSearchHandler from '../leads/_CustomSearchHandler';
import { log } from 'console';
import { el } from 'date-fns/locale';
import ExportExcelPopUp from '../leads/_ExportExcelPopUp';
import { ClientPopup } from '../clients/_ClientPopup';
import SalespersonAssignment from './_salespersonAssignment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHammer } from '@fortawesome/free-solid-svg-icons';
import ClientAddTreatmentPopup from '../clients/_ClientAddTreatmentPopup';
import { setLeadIdForTreatment, setLeadTreatmentPopUp, setLeadTreatmentType, setDocumentLeadTaskUrl, setLeadsData, setRedirectToLeads } from '../app-context/leadsSlice';
import { TaskDocumentPopup } from '../tasks/_TaskDocumentPopup';
import { RiderRenewal } from './_RiderRenewal';
import RenewalsConfigPopup from './_RenewalsConfigPopup'
import { SubscriberPopup } from '../subscribers/_SubscriberPopup'
import NumericalMarkingPopup from './_numericalMarkingPopup';
import RenewalOfferPopup from './_RenewalOfferPopup';

export declare type SingleValue<Option> = Option | null;


const { TreeNode } = TreeSelect;
type Option = { value: number; label: string };
type Props = {
  offerIdData: string | null;
  leadId: string | null;
  idForLeadPopup: string | null;
  setIdForLeadPopup: (id: string | null) => void;
  setBranchesData: (data: any) => void;
  leadTreatmentPopUp: boolean;
  setLeadTreatmentPopUp: (open: boolean) => void;
  setLeadIdForTreatment: (id: string) => void;
  setLeadTreatmentType: (type: number) => void;
  setDocumentLeadTaskUrl: (url: any[]) => void;
  leadTreatmentType: number;
  leadIdForTreatment: string;
  documentLeadTaskUrl: any[];
  leadsData: {
    actionName: string | null;
    allRowsCounter: number;
    leads: any[];
    pageSize: number;
  };
  setLeadsData: (data: any) => void;
  setRedirectToLeads: (redirect: boolean) => void;
  redirectToLeads: boolean;
};
type State = {
  data: LeadsPageModel | null;
  leadsList: SPLeadModel[];
  ridersList: RiderLeadModel[];
  name: string;
  IdForPopup: string | null;
  IdForViewPopup: string | null;
  userLogged: boolean;
  leadDocumentUrl: string | null;
  messageContent: string | null;
  promptContent: string | null;
  promptTitle: string;
  selectedLead: LeadModel | null;
  advancedSearchOpen: boolean;
  createDateFrom?: Date | undefined | null;
  createDateTo?: Date | undefined | null;

  //closeDateFrom?: Date | undefined | null;
  // closeDateTo?: Date | undefined | null;
  // deliveryDateFrom?: Date | undefined | null;
  // deliveryDateTo?: Date | undefined | null;
  carYear?: Date | undefined | null;
  carYears: Array<string>;
  lastStatusDate?: Date | undefined | null;
  filter: any;
  AuthorizedToDrive: IDNameDescriptionDictionary;
  searchStatuses: IDNameDescriptionDictionary;
  selectedStatus: string;
  selectedCarYear: string;
  leadStatuses: any[];
  advSearchOptions: any;
  LeadTypes: IDNameDescriptionDictionary;
  InsuranceCompanies: IDNameDescriptionDictionary;
  // רכב
  manufacturer: string;
  manufactures: any[],
  manufacturesList: any[],
  VehicleModelAutocomplete: Array<AutocompleteData>;
  VehicleModelAll: any
  VehicleSubModelAutocomplete: Array<AutocompleteData>;
  vehicleModels: any[];
  vehicleSubModels: any[];
  VehicleSubModelAll: any[];
  // 
  clearFilter: boolean;
  dataLoaded: boolean;
  currentPage: number;
  pagerConf: any;
  loading: boolean;
  sortLeedsBy: any | null;
  InsuranceTypes: IDNameDescriptionDictionary;
  VehicleInsuranceTypes: IDNameDescriptionDictionary;
  allBranches: any[];
  allUsers: any[]
  treeData: any[];
  treeDataForPopUp: any[],
  treeDataValue: string | null,
  isAdmin: boolean
  selectedLeadId: string | null,
  openedLeadId: string | null
  apiUrl: string | null;
  searchText: string | undefined;
  notLogged: boolean;
  creatorsList: IDNameDescriptionDictionary;
  LeadTopType: IDNameDescriptionDictionary;
  salesPeopleList: any[];
  selectedSaleManName: string | undefined;
  selectedRenewalManName: string | undefined;
  offerIdData: string | null;
  leadId: string | null;
  agentsList: any[];
  salesPeopleListOrigin: any[];
  treeDataBrunches: any[];
  showExport: boolean;
  showPopupModel: boolean;
  popUpContent: string;
  popUptitle: string;
  isSalespersonAssignment: boolean;
  renewalHandlers: any;
  renewalUserId: string | undefined;
  isShowRenewalsConfigPopup: boolean;
  ShowAllDataMessage: boolean;
  byFilter: boolean;
  sendSalespersonAssignmentError: boolean;
  riderForRenewPopup: RiderModel | undefined;
  numericalMarking: boolean;
};

class Renewals extends React.Component<Props, State> {
  simulatorModel: SimulatorModel = new SimulatorModel();
  leadsModel: LeadsModel = new LeadsModel();
  renewalsModel: RenewalsModel = new RenewalsModel();
  loginModel: LoginModel = new LoginModel();
  generalModel: GeneralDataModel = new GeneralDataModel();
  selectedLeadId: string = '';
  timeoutId: any;
  // pagerConf: any = {};
  // userLogged = useSelector((state: any) => state.user.value)
  
  policyTypes: IDNameDescriptionDictionary = {
    '0': {
      id: 0,
      name: 'סוג פוליסה',
      description: 'סוג פוליסה'
    }
  }

  monthNames = [
    "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
    "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר",
  ];
  monthOptions: Option[] = this.monthNames.map((m, i) => ({
    value: i + 1,
    label: m,
  }));

  yearsOptions: Option[] = [];

  constructor(props: Props) {
    super(props);
    this.closeShowRenewalsConfigPopup = this.closeShowRenewalsConfigPopup.bind(this);
    this.closeNewLead = this.closeNewLead.bind(this);
    this.closeDocumentPopup = this.closeDocumentPopup.bind(this);
    this.closeAdvancedSearch = this.closeAdvancedSearch.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.getAuthorizedToDriveName = this.getAuthorizedToDriveName.bind(this);
    this.closeViewPopup = this.closeViewPopup.bind(this);


    // this.onModelChange = this.onModelChange.bind(this);
    const filter: any = {};
    filter.StatusIdSearch = '00000000-0000-0000-0000-000000000000';
    this.state = {
      data: null,
      leadsList: [],
      ridersList: [],
      name: "Leads",
      IdForPopup: null,
      IdForViewPopup: null,
      userLogged: true,
      leadDocumentUrl: null,
      messageContent: null,
      promptContent: null,
      promptTitle: 'מחיקת ליד',
      advancedSearchOpen: false,
      AuthorizedToDrive: new IDNameDescriptionDictionary(),
      filter: new RenewalsFilterModel(),
      selectedLead: null,
      searchStatuses: new IDNameDescriptionDictionary(),
      selectedStatus: 'סטטוס',
      selectedCarYear: 'שנת יצור',
      leadStatuses: [],
      advSearchOptions: {},
      LeadTypes: new IDNameDescriptionDictionary(),
      InsuranceCompanies: new IDNameDescriptionDictionary(),
      manufacturer: '',
      manufactures: [],
      manufacturesList: [],
      vehicleModels: [],
      vehicleSubModels: [],
      clearFilter: false,
      dataLoaded: false,
      currentPage: 1,
      loading: false,
      sortLeedsBy: null,
      InsuranceTypes: generalSettings.InsuranceTypes,
      treeData: [],
      treeDataForPopUp: [],
      treeDataValue: null,
      allBranches: [],
      allUsers: [],
      pagerConf: {
        pageSize: 0,
        currentPage: 1,
        totalItems: 0
      },
      isAdmin: false,
      selectedLeadId: null,
      openedLeadId: null,
      apiUrl: localStorage.getItem('apiUrl'),
      searchText: '',
      notLogged: false,
      creatorsList: new IDNameDescriptionDictionary(),
      LeadTopType: new IDNameDescriptionDictionary(),
      VehicleInsuranceTypes: new IDNameDescriptionDictionary(),
      VehicleModelAutocomplete: [],
      VehicleModelAll: [],
      VehicleSubModelAutocomplete: [],
      VehicleSubModelAll: [],
      carYears: [],
      salesPeopleList: [],
      selectedSaleManName: undefined,
      selectedRenewalManName: undefined,
      offerIdData: this.props.offerIdData,
      leadId: this.props.leadId,
      agentsList: [],
      salesPeopleListOrigin: [],
      treeDataBrunches: [],
      showExport: false,
      showPopupModel: false,
      popUpContent: "",
      popUptitle: "",
      isSalespersonAssignment: true,
      renewalHandlers: [],
      renewalUserId: undefined,
      isShowRenewalsConfigPopup: false,
      ShowAllDataMessage: false,
      byFilter: false,
      sendSalespersonAssignmentError: false,
      riderForRenewPopup: undefined,
      numericalMarking:false
    }
    // this.pagerConf = {
    //   pageSize: 0,
    //   currentPage: 0,
    //   totalItems: 0
    // }



  }

  showHidePopup() {
    this.setState({ showPopupModel: false });

  }


  componentDidMount() {
    const treeData: any[] = [
    ];
    let loggedUser: any = localStorage.getItem('loggedUser');
    if (loggedUser) {
      loggedUser = JSON.parse(loggedUser);
      this.setState({
        isAdmin: loggedUser.role == 0 || loggedUser.role == 7 || loggedUser.role == 10
      })

      this.setState({
        treeData,
        treeDataForPopUp: [],
        searchText: ''
      }, () => {
        this.init();
      });
    }
  }

  async init() {
    let loggedUser: any = localStorage.getItem('loggedUser');
    // let salesMansList: any[] = await this.simulatorModel.getCustomerCardHandlers();
    let salesMansList: any[] = [];


    let salesManListStorage: any = localStorage.getItem('handlersList');


    const renewalsYears = await this.renewalsModel.renewalsGetYears();
    this.yearsOptions = renewalsYears.map((year: number) => ({
      value: year,
      label: year.toString(),
    }));

    const renewalHandlers = await this.generalModel.getSalesHandlers();
    salesMansList = await this.generalModel.getSalesHandlers();
    var agentId = salesMansList[0].agentId;
    salesMansList.unshift({
      fullName: "שויך",
      id: "0",
      status: "0",
      agentId: agentId
    });
    salesMansList.unshift({
      fullName: "לא שויך",
      id: "1",
      status: "0",
      agentId: agentId
    });
    var r = renewalHandlers.map((person: any) => {
      return {
        label: person.fullName,
        value: person.id,
        status: person.status,
        agentId: person.agentId

      }
    });

    // if (salesManListStorage) {
    //   salesMansList = JSON.parse(salesManListStorage);
    // } else {
    //   salesMansList = await this.simulatorModel.getCustomerCardHandlers();


    // }
    // localStorage.setItem('handlersList', JSON.stringify(r));
    this.setState({ renewalHandlers: r });


    let agents: any[] = []
    let agentsFromStorage: any = localStorage.getItem('agents');
    if (agentsFromStorage) {
      agents = JSON.parse(agentsFromStorage);
    } else {
      agents = await this.simulatorModel.getCustomerCardAgents();
      localStorage.setItem('agents', JSON.stringify(agents));
    }

    if (!loggedUser) {
      this.loginModel.logOut();
    } else {
      loggedUser = JSON.parse(loggedUser);


      let newAgentsList = agents.filter((a: any) => {
        if (a.parentId) {
          return a.id === loggedUser.agentId || a.parentId === loggedUser.agentId;
        } else {
          return a.id === loggedUser.agentId;
        }
      })

      this.setState({ agentsList: [...newAgentsList] });


      let salesPeoples: any[] = [];


      salesPeoples = salesMansList.map((person: any) => {
        return {
          label: person.fullName,
          value: person.id,
          status: person.status,
          agentId: person.agentId

        }
      });




      const newStateData: any = {
        salesPeopleList: salesPeoples.filter((sp: any) => sp.agentId === loggedUser.agentId),
        salesPeopleListOrigin: salesPeoples
      }

      this.setState(newStateData);


      // getLeadsAndStatuses
      this.getLeadsAndStatuses().then(async () => {
        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        if (lastFilterStr && lastFilterStr !== '{}') {

          const filter = JSON.parse(lastFilterStr);
          if (loggedUser) {
            filter.agentId = loggedUser.agentId;
          }
          if (filter.StatusIdSearch) {
            let selectedStatus = localStorage.getItem('lastSelectedStatus');

            if (selectedStatus) {
              this.setState({
                selectedStatus: selectedStatus
              })
            }
          }
          if (filter.searchText) {
            await this.setState({
              searchText: filter.searchText,
              filter
            })
          }





          this.load(filter);
        } else {
          //console.log('else filter', lastFilterStr);
          const filter: any = {};
          delete filter.searchText;
          delete filter.BranchType;
          delete filter.branchType;
          delete filter.BranchId;
          filter.StatusIdSearch = undefined;
          filter.page = 1;

          if (loggedUser) {
            filter.agentId = loggedUser.agentId;



            if (loggedUser.role == 6 || loggedUser.role == 13) {
              const currentSaleMan = salesMansList.find((sp: any) => sp.email == loggedUser.email);
              if (currentSaleMan) {
                filter.salesUserId = currentSaleMan.id;
              }
              if (currentSaleMan) {
                filter.salesUserId = currentSaleMan.id;
              }
              this.load(filter);
            } else {
              this.load(filter);
            }
          }
        }
      });
    }

    var carYears = [];
    carYears.push("שנת יצור");
    for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
      carYears.push(i + "");
    }
    const creatorsList = await this.generalModel.customerCardGetCreators();
    localStorage.setItem('creatorsList', JSON.stringify(creatorsList));
    const creators = new IDNameDescriptionDictionary();
    creators['0'] = {
      description: 'יוצר הליד',
      name: 'יוצר הליד',
      id: 0
    };
    creatorsList.forEach((p: any) => {
      creators[p.id] = {
        description: p.fullName,
        name: p.fullName,
        id: p.id,
        active: p.status === 0
      };
    });

    this.policyTypes = await this.generalModel.getPolicyTypes();
    const manufactures = await this.generalModel.getVehicleManufaucters();
    localStorage.setItem('leadsAdvancedSearchOptions', JSON.stringify({
      manufactures
    }));
    const vehicleModels = await this.generalModel.getVehicleModels(undefined);
    const vehicleSubModels = await this.generalModel.getVehicleSubModels(undefined);
    let subModelsList: any[] = vehicleSubModels.filter((sm: any) => sm.text !== null && sm.text !== '');

    subModelsList = subModelsList.map((sm: any) => {
      let label = sm.text.trim();
      if (sm.code && sm.code !== '' && sm.code !== '0') {
        label = `[${sm.code}]${label}`;
      }
      return {
        code: sm.code,
        text: sm.text.trim(),
        label: label,
        value: sm.value
      }
    })


    this.setState({
      manufactures,
      manufacturesList: manufactures,
      vehicleModels,
      VehicleModelAll: vehicleModels,
      VehicleModelAutocomplete: vehicleModels,
      vehicleSubModels: subModelsList,
      VehicleSubModelAll: subModelsList,
      VehicleSubModelAutocomplete: subModelsList,
      LeadTypes: this.getLeadTypes(),
      InsuranceCompanies: await this.getInsuranceCompanies(),
      carYears: carYears,
      creatorsList: creators,
      LeadTopType: this.policyTypes,
      VehicleInsuranceTypes: await this.getVehicleInsuranceTypes(),
    });

  }

  async getVehicleInsuranceTypes(): Promise<IDNameDescriptionDictionary> {
    const VehicleInsuranceTypes = await this.generalModel.getAppDictionaryListExpanded();



    const entries = Object.entries(VehicleInsuranceTypes).map(
      ([key, value]) => [`item_${key}`, value]  // make keys non-numeric
    );

    const _transformed: IDNameDescriptionDictionary = Object.fromEntries([
      ["first", { id: "", name: "סוג ביטוח רכב", description: "סוג ביטוח רכב"}],
      ...entries
    ]);



    return _transformed;
  }

  async getInsuranceCompanies(): Promise<IDNameDescriptionDictionary> {
    const insuranceCompanies = await this.generalModel.getInsuranceCompanies();

    const transformed: IDNameDescriptionDictionary = {
      "0": {
        id: "",
        name: "חברת ביטוח",
        description: "חברת ביטוח"
      },
      ...(
        Object.entries(insuranceCompanies) as [string, IDNameDescriptionItem][]
      ).reduce((acc, [key, value]) => {
        acc[key] = {
          id: value.description ? value.description : "",
          name: value.name,
          description: value.name ? value.name : ""
        };
        return acc;
      }, {} as IDNameDescriptionDictionary)
    };

    return transformed;
  }
  getLeadTypes(): IDNameDescriptionDictionary {
    // const types = new IDNameDescriptionDictionary();
    return {
      '0': {
        description: 'סוג ליד',
        name: 'סוג ליד',
        id: -1
      },
      '1': {
        description: 'חדש',
        name: 'חדש',
        id: 0
      },
      '2': {
        description: 'משומש',
        name: 'משומש',
        id: 2
      },
      '3': {
        description: 'סלקט',
        name: 'סלקט',
        id: 1
      }
    }
  }

  onChangePage(newPage: number) {
    // //console.log('onChangePage', newPage);
    const pagerConf = this.state.pagerConf;
    pagerConf.currentPage = newPage;
    const filter = this.state.filter;
    filter.page = newPage + 1;
    this.setState({
      currentPage: newPage,
      pagerConf: pagerConf,
      filter: filter
    }, () => this.load(filter));
  }




  onStationUserChange(data: any) {
    const filter = this.state.filter;
    filter.BranchId = data.BranchId;
    filter.stationUserId = data.stationUserId;
    this.setState({
      filter: filter
    });
    if (data.BranchId !== undefined || data.stationUserId !== undefined) {
      this.setState({
        clearFilter: false
      })
    }
  }

  scrollToLead = (leadId: string) => {
    const element = document.getElementById(`lead-row-${leadId}`);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  async load(filterObj?: any) {
    this.setState(
      {
        loading: true,
        leadsList: []
      }
    );

    const newStateData: any = {

    }
    let filter: any = {};
    filter.page = this.state.currentPage + 1;

    const lastFilterStr = localStorage.getItem('lastLeadsFilter');
    let savedFilter: any = {};
    if (lastFilterStr && lastFilterStr !== '{}') {
      savedFilter = JSON.parse(lastFilterStr);
    }
    // const savedState = localStorage.getItem('lastLeadsState');
    // if (savedState) {
    //   const sData = JSON.parse(savedState);
    //   if (Object.keys((sData)).length > 0) {
    //     this.setState(sData);
    //   }
    // }

    if (filterObj) {
      if (savedFilter.searchText && savedFilter.searchText != "") {
        filterObj["searchText"] = savedFilter.searchText;
      }
      filter = filterObj;
    } else {
      filter = savedFilter;

    }
    if (filter.StatusIdSearch) {

    }

    if (filter.searchText) {
      // await this.setState({
      //   searchText: filter.searchText
      // })
      newStateData.searchText = filter.searchText;
    }
    if (filter.carYear) {
      // selectedCarYear
      // this.setState({
      //   selectedCarYear: filter.carYear
      // });
      newStateData.selectedCarYear = filter.carYear;
    }

    if (filter.salesUserId) {
      setTimeout(() => {

        console.log('salesPeopleList selected 1', this.state.salesPeopleListOrigin)
        const selected = this.state.salesPeopleListOrigin.find((sp: any) => sp.value == filter.salesUserId);
        if (selected) {
          this.setState({
            selectedSaleManName: selected.label
          });
        }


      }, 1000);

      
    }
    
    if (filter.manufacturerId) {
      setTimeout(() => {
        const selected = this.state.manufacturesList.find((sp: any) => sp.value == filter.manufacturerId);
        if (selected) {
          this.setState({
            manufacturer: selected.text
          });
        }
      }, 1000);
    }

    if (filter.stationUserId) {
      const lastTreeDataValue = localStorage.getItem('lastTreeDataValue');
      if (lastTreeDataValue) {
        // this.setState({
        //   treeDataValue: lastTreeDataValue
        // });
        newStateData.treeDataValue = lastTreeDataValue;
      }
    }
    const savedLeadId = localStorage.getItem('offeredLeadId');
    if (savedLeadId && savedLeadId !== '') {
      // await this.setState({
      //   openedLeadId: savedLeadId
      // })
      newStateData.openedLeadId = filter.savedLeadId;
    }


    let model: any = {}
    try {
      if (filter.leadType == '-1') {
        filter.leadType = undefined;
      }
      model = await this.leadsModel.renewalsfilter(filter);

      if (model && model.status && model.status == 401) {
        this.loginModel.logOut();
        this.setState({
          notLogged: true
        })
      }
    } catch (error) {

      model = {
        pageSize: 25,
        currentPage: 0,
        leads: []
      }
    }
    // 
    localStorage.setItem('lastLeadsFilter', JSON.stringify(filter));

    if (this.state.data) {
    } else {
      setTimeout(async () => {
        await this.getLeadsAndStatuses();
      }, 200);
    }


    const pagerConf = {
      pageSize: model && model.pageSize ? model.pageSize : 25,
      currentPage: this.state.currentPage,
      totalItems: model && model.allRowsCounter ? model.allRowsCounter : 0
    }


    if (!filter.leadType) {
      filter.leadType = '-1';
    }
    if (model) {
      // this.setState({
      //   data : model,
      //   leadsList: model.leads ? model.leads : [],
      //   name : "Leads",
      //   AuthorizedToDrive: await this.simulatorModel.getAuthorizedToDriveItems(),
      //   filter: filter,
      //   pagerConf: pagerConf
      // });
      const authorizedToDrive = await this.simulatorModel.getAuthorizedToDriveItems()
      newStateData.data = model;
      newStateData.leadsList = model.leads ? model.leads : [];
      newStateData.ridersList = model.riders ? model.riders : [];
      newStateData.name = "Leads";
      newStateData.AuthorizedToDrive = authorizedToDrive;
      newStateData.filter = filter;
      newStateData.pagerConf = pagerConf;
    }

    const insuranceTypesStr = localStorage.getItem('insuranceTypes');
    if (!insuranceTypesStr) {
      const insuranceTypes = await this.simulatorModel.getInsuranceTypes()
      localStorage.setItem('insuranceTypes', JSON.stringify(insuranceTypes))
    }


    await this.buildTreeSelectData();

    await this.buildTreeSelectDataForBrunches();

    if (savedLeadId && savedLeadId !== '') {
      setTimeout(() => {
        this.scrollToLead(savedLeadId);
        this.setState({
          openedLeadId: null
        });
        localStorage.removeItem('offeredLeadId');
      }, 1000);
    }

    newStateData.loading = false;
    newStateData.dataLoaded = true;

    this.setState(
      newStateData,
      () => {
        setTimeout(async () => {
          this.setState({
            dataLoaded: false
          })
        }, 100);
      }
    );
  }

  async getCustomerDetailsById(id: string) {
    // getCustomerDetailsById
    return await this.simulatorModel.getCustomerDetailsById(id);
  }

  async getLeadsAndStatuses() {
    const statuses = await new RenewalsModel().GetLeadStatuses(1);
    //const statuses = await this.leadsModel.getLeadStatuses();
    if (statuses) {
      const searchStatuses = new IDNameDescriptionDictionary();
      searchStatuses['0'] = {
        description: 'סטטוס',
        name: 'סטטוס',
        id: 0
      }
      searchStatuses['00000000-0000-0000-0000-000000000000'] = {
        description: 'כל הסגורים',
        name: 'כל הסגורים',
        id: '00000000-0000-0000-0000-000000000000'
      }

      statuses.forEach((status: any) => {
        searchStatuses[status.value] = {
          description: status.text,
          name: status.text,
          id: status.value
        }
      })

      await this.setState({
        searchStatuses: searchStatuses as IDNameDescriptionDictionary,
        leadStatuses: statuses
      });
    }
    // return model;
  }


  async setAdvancedSearchOptions() {
    const manufactures = await this.generalModel.getVehicleManufaucters();
    const vehicleModels = await this.generalModel.getVehicleModels(undefined);
    const vehicleSubModels = await this.generalModel.getVehicleSubModels(undefined);

    let subModelsList: any[] = vehicleSubModels.filter((sm: any) => sm.text !== null && sm.text !== '');

    subModelsList = subModelsList.map((sm: any) => {
      let label = sm.text.trim();
      if (sm.code && sm.code !== '' && sm.code !== '0') {
        label = `[${sm.code}]${label}`;
      }
      return {
        code: sm.code,
        text: sm.text.trim(),
        label: label,
        value: sm.value
      }
    })

    localStorage.setItem('leadsAdvancedSearchOptions', JSON.stringify({
      manufactures
    }));

    this.setState(
      {
        manufactures,
        manufacturesList: manufactures,
        vehicleModels,
        VehicleModelAutocomplete: vehicleModels,
        vehicleSubModels: subModelsList,
        VehicleSubModelAll: subModelsList,
        VehicleSubModelAutocomplete: subModelsList
      }
    )

  }


  setFilter(name: string, value: string | null) {
    // 
    if (this.state != null) {
      var filter = this.state.filter;
      filter[name] = value;
      this.setState({ filter: filter });
      // this.filter();
    }

  }

  setFilterInput(name: string, event: any) {
    // 
    if (this.state != null) {
      var filter = this.state.filter;
      const newSearchValue = event.target.value;
      if (filter[name] !== newSearchValue) {
        filter[name] = newSearchValue;
        this.setState({ filter: filter });
        if (name == 'searchText') {
          this.filter();
        }
      }
    }
  }

  async handleSearchChange(name: string, event: any) {
    if (this.state != null) {
      var filter = this.state.filter;
      const newSearchValue = event.target.value;
      if (filter[name] !== newSearchValue) {

        filter[name] = newSearchValue;
        await this.setState({ filter: filter, searchText: newSearchValue });

        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
          savedFilter = JSON.parse(lastFilterStr);
          savedFilter.searchText = newSearchValue;
          localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
        }

      }
      if (newSearchValue === '') {
        this.clearFilterValue('searchText')
      }
    }
  };

  onAgentChange = (value: string) => {
    const filter = this.state.filter;
    filter['agentId'] = value;

    let salesMansListByAgent = this.state.salesPeopleListOrigin.filter((sm) => sm.agentId == value)
    this.setState({
      filter,
      salesPeopleList: salesMansListByAgent,
    });

  }


  onSearchTextKeyPress(name: string, event: any) {
    if (event.key === 'Enter') {
      this.filter();
    }
  }

  setFilterInputAndFilter(name: string, event: any) {
    // 
    if (this.state != null) {
      var filter = this.state.filter;
      filter[name] = event.currentTarget.value ? event.currentTarget.value : null;
      this.setState({ filter: filter });
      //   this.filter();
    }
  }

  onStationUserIdChange = (name: string, value: string) => {
    // if(this.state!=null){
    var filter = this.state.filter;
    if (!value || value == '0') {
      delete filter[name];
      delete filter['BranchType'];
    } else {
      switch (name) {
        case 'stationUserId':
          if (parseInt(value) > 0 && parseInt(value) < 4) {
            filter['BranchType'] = value;
          }
          break;

        default:
          filter[name] = value;
          break;
      }

    }
    this.setState({ filter: filter });
    this.filter();
    // }
  }

  onStatusChange = (name: string, value: string) => {
    // if(this.state!=null){
    var filter = this.state.filter;
    if (!value || value == '0') {
      delete filter[name];
    } else {
      filter[name] = value;
    }
    this.setState({ filter: filter });
    this.filter();
    // }
  }

  onCarYearChange = (value: string) => {
    const filter = this.state.filter;
    filter.carYear = value === 'שנת יצור' ? undefined : value

    this.setState({
      filter,
      selectedCarYear: value
    });
  }

  onStatusChange2 = (value: string) => {
    let selectedStatus: string = 'סטטוס';
    const filter = this.state.filter;
    if (value.toString() !== '0') {
      Object.keys(this.state.searchStatuses).forEach((k: string) => {
        if (this.state.searchStatuses[k].id == value) {
          const option = this.state.searchStatuses[k];
          selectedStatus = option.name ? option.name : 'סטטוס';
          filter.StatusIdSearch = value.toString();
        }
      });
    } else {
      delete filter.StatusIdSearch;
      selectedStatus = 'סטטוס';
    }
    localStorage.setItem('lastSelectedStatus', selectedStatus)
    this.setState({
      filter,
      selectedStatus
    }, () => {
      // this.filter()
    });

  }

  clearFilterValue(name: string) {
    var filter = this.state.filter;
    filter[name] = null;

    switch (name) {
      case 'searchText':
        filter[name] = '';
        this.setState({ searchText: '' })
        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
          savedFilter = JSON.parse(lastFilterStr);
          savedFilter.searchText = '';
          localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
        }
        break;
      case 'manufacturerId':
        // this.setState({manufacturer: ''})
        const mList = this.state.vehicleModels
        this.setState({
          VehicleModelAutocomplete: mList,
          VehicleModelAll: mList,
          manufacturer: '',
        });

        filter.vehicleModelId = null;
        filter.vehicleModel = '';
        break;

      default:
        break;
    }
    this.setState({ filter: filter });
  }

  prepareFilterData() {
    let filter = this.state.filter;
    debugger;
    if (!filter.page) {
      filter.page = 1;
    }
    if (filter.searchText) {
      filter.searchText = filter.searchText.trim();
    }
    if (filter.leadType == '-1') {
      filter.leadType = undefined;
    }
    if (filter.policyType == '0') {
      filter.policyType = undefined;
    }
    if (filter.vehicleModel == '') {
      filter.vehicleModel = undefined
    }
    if (filter.vehicleSubModel == '') {
      filter.vehicleSubModel = undefined
    } else {
      if (filter.vehicleSubModelId == '') {
        const submodelObj = this.findSubModelByText(filter.vehicleSubModel);
        if (submodelObj) {
          filter.vehicleSubModelId = submodelObj.value;
          filter.vehicleSubModel = undefined;
        } else {
          filter.vehicleSubModel = undefined;
          filter.vehicleSubModelId = undefined
        }
      }
    }
    return filter;
  }

  async filter() {
    let filter = this.prepareFilterData();
    this.setState({
      data: new LeadsPageModel()
    }, () => this.load(filter))
  };


  async clearFilterAll() {
    // const currFilter = this.state.filter;
    const filter: any = {};


    filter.StatusIdSearch = undefined;
    filter.vehicleModel = '';
    filter.vehicleSubModel = '';
    filter.leadType = '-1';
    filter.policyType = undefined;
    filter.page = 1;

    this.props.setBranchesData({ project: '', branch: '', user: '' });

    const lastFilterStr = localStorage.getItem('lastLeadsFilter');
    let savedFilter: any = {};
    if (lastFilterStr && lastFilterStr !== '{}') {
      savedFilter = JSON.parse(lastFilterStr);
      savedFilter.searchText = '';
      localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
    }
    await this.setState({
      filter: filter,
      clearFilter: true,
      treeDataValue: '',
      searchText: '',
      selectedSaleManName: undefined,
      // salesPeopleList: [],
      openedLeadId: null,
      selectedStatus: 'סטטוס',
      selectedCarYear: 'שנת יצור',
      manufacturer: '',

    }, () => {
      let filter = this.prepareFilterData();
      this.load(filter);
    });

  }

  getAuthorizedToDriveName(authorizedToDriveId: number) {
    if (authorizedToDriveId != null) {
      var item = this.state.AuthorizedToDrive[authorizedToDriveId];
      if (item != null) {
        return item.description;
      }
    }
  }

  checkPermissionsOfSimulator() {
    let loggedUser: any = localStorage.getItem('loggedUser');
    if (loggedUser) {
      loggedUser = JSON.parse(loggedUser);
      let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'simulator');

      if (moodelPermision && moodelPermision.permissionType == 2) {
        return true;
      }
    }
    return false;
  }

  checkPermissionsOfCreator() {
    let loggedUser: any = localStorage.getItem('loggedUser');
    if (loggedUser) {
      loggedUser = JSON.parse(loggedUser);
      let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');

      if (moodelPermision && moodelPermision.permissionType == 2) {
        return true;
      }
    }
    return false;
  }

  onCheckRenewal(leadId: string, isShift: boolean) {
    var leads = this.state.leadsList;

    const targetIndex = leads.findIndex((lead: SPLeadModel) => lead && lead.lead && lead.lead.id === leadId);
    if (targetIndex === -1) return leads; // not found

    const updatedLeads = [...leads];
    if (!isShift || updatedLeads[targetIndex].checked) {
      updatedLeads[targetIndex] = new SPLeadModel({
        ...updatedLeads[targetIndex],
        checked: !updatedLeads[targetIndex].checked
      });
    }
    else {
      for (let i = targetIndex - 1; i >= 0; i--) {
        if (updatedLeads[i].checked) break; // stop when you hit a checked one
        updatedLeads[i] = new SPLeadModel({
          ...updatedLeads[i],
          checked: true
        });

      }
    }
    this.setState({ leadsList: updatedLeads });

  }

  isAllRenewalsChecked() {
    return this.state.leadsList.every(lead => lead.checked);

  }

  checkAllRenewals() {
    const updatedLeads = this.state.leadsList.map(lead => (new SPLeadModel({
      ...lead,
      checked: true
    })));

    this.setState({ leadsList: updatedLeads, ShowAllDataMessage: true, byFilter: false });
  }

  uncheckAllRenewals() {
    const updatedLeads = this.state.leadsList.map(lead => (new SPLeadModel({
      ...lead,
      checked: false
    })));

    this.setState({ leadsList: updatedLeads, ShowAllDataMessage: false, byFilter: false });
  }

  checkPermissionsOfEdit() {
    let loggedUser: any = localStorage.getItem('loggedUser');
    if (loggedUser) {
      loggedUser = JSON.parse(loggedUser);
      let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');

      if (moodelPermision && moodelPermision.permissionType == 2 && (loggedUser.role < 1 || loggedUser.role > 5)) {
        return true;
      }
    }
    return false;
  }


  async renewalImport() {

    await this.renewalsModel.renewalImport();
    this.setState({ showPopupModel: true, popUpContent: "יבוא חידושים", popUptitle: "החידושים נוצרו בהצלחה!" });
    this.load(this.state.filter);
  }

  async showRenewalsConfigPopup() {
    this.setState({ isShowRenewalsConfigPopup: true });
  }

  async closeShowRenewalsConfigPopup() {
    this.setState({ isShowRenewalsConfigPopup: false });
  }





  async salespersonAssignment() {
    let isSalespersonAssignment = this.state.isSalespersonAssignment;
    if (isSalespersonAssignment) {
      this.setState({ isSalespersonAssignment: false });

    }
    else {
      this.setState({ isSalespersonAssignment: true });
    }

  }
  async sendSalespersonAssignment() {
    if (this.state.renewalUserId != undefined) {
      if (this.state.byFilter) {

        const checkedIds = this.state.leadsList.filter(item => item && item.lead && item.checked)
          .map(item => item && item.lead ? item.lead.id : "");
        var filter = this.state.filter;
        filter.handlerToLink = this.state.renewalUserId
        if (filter.leadType == '-1') {
          filter.leadType = undefined;
        }
        await this.renewalsModel.renewalLinkSalespersonByFilter(filter);

        this.load(this.state.filter);
        this.setState({ showPopupModel: true, popUpContent: "שיוך חידושים ללקוח", popUptitle: "השיוך בוצע בהצלחה!" });
      }
      else {
        const checkedIds = this.state.leadsList.filter(item => item && item.lead && item.checked)
          .map(item => item && item.lead ? item.lead.id : "");
        let body: any = {};
        body.salespersonId = this.state.renewalUserId;
        body.leads = checkedIds;
        await this.renewalsModel.renewalLinkSalesperson(body);

        this.load(this.state.filter);
        this.setState({ showPopupModel: true, popUpContent: "שיוך חידושים ללקוח", popUptitle: "השיוך בוצע בהצלחה!" });
      }
    }
    else {
      this.setState({ sendSalespersonAssignmentError: true });
    }
  }



  async sendSalespersonAssignmentAllFilter() {

    this.setState({ byFilter: true });
  }

  async clearByFilter() {

    this.setState({ byFilter: false });
  }


  async sendSalespersonAssignmentByLetters() {
    await this.renewalsModel.renewalLinkSalespersonByLetters();
    this.setState({ isSalespersonAssignment: false });
    this.load(this.state.filter);
    this.setState({ showPopupModel: true, popUpContent: "שיוך חידושים ללקוח", popUptitle: "השיוך בוצע בהצלחה!" });
  }
  
closeViewPopup() {
    this.setState({ IdForViewPopup: null });
  }

  closeNewLead(status?: string) {

    this.setState({ IdForPopup: null }, () => {
      this.props.setIdForLeadPopup(null);
      if (status && status == 'success') {
        this.load(this.state.filter);
      }
    });
  }

  closeDocumentPopup() {
    this.setState({ leadDocumentUrl: null });
  }

  closeMessagePopup() {
    this.setState({ messageContent: null });
  }

  onHideDocumentPopUp() {
    this.props.setDocumentLeadTaskUrl([]);
  }

  closeExportPopUp() {
    this.setState({})
  }
  openMessagePopUp(popUpText: string) {
    this.setState({ messageContent: popUpText });
  }
  closePromptPopup() {
    this.setState({ promptContent: null });
  }
  openPromptPopUp(promptText: string, propmptTitle: string) {
    this.setState({
      promptContent: promptText,
      promptTitle: propmptTitle
    });
  }
  onPromptApprove() {
    if (this.state.selectedLeadId) {
      this.onDeleteLead(this.state.selectedLeadId);
    }
    this.setState({ promptContent: null });
  }

  openDocumentPopup(docUrl: string) {
    const fileUrl = `${this.state.apiUrl}${docUrl}`;
    this.setState({ leadDocumentUrl: fileUrl });
  }

  updateLeadStatus(leadId: string, newStatusId: string) {
    try {
      const leadsList = this.state.leadsList;
      const leadIndex = leadsList.findIndex((l: any) => l.lead.id == leadId);
      if (leadIndex > -1) {
        const newStatus = this.state.leadStatuses.find((ls: any) => ls.value == newStatusId);
        if (newStatus) {
          leadsList[leadIndex].lastStatusId = newStatus.value;
          leadsList[leadIndex].lastStatusName = newStatus.text;
        }
        this.setState({
          leadsList: leadsList
        })
      }
      const res = this.leadsModel.updateLeadStatus({
        Id: leadId,
        LastStatusId: newStatusId
      });
    } catch (error) {

    }
  }

  setStateData = (name: string, value: any) => {
    debugger;
    console.log(name, value);

    const filter = this.state.filter;
    filter[name] = value;
    if(value=="")
      filter[name] = undefined;
    // if(name.indexOf('Date') > -1) {
    //     this.updateDateDate(name, value);
    // }

    if(name=="salesUserId"){
      if(value=="1"){
        filter.salesUserId=undefined;
        filter.noHandler=true;
      }else if(value=="0"){
        filter.salesUserId=undefined;
        filter.noHandler=false;
      }
      else{
        filter.salesUserId=value;
        filter.noHandler=undefined;
      }
    }

    this.setState({ filter: filter });
  }

  setStateDataAndFilter = (name: string, value: any) => {
    const filter = this.state.filter;
    // this.setStateData(name, value);
    if (name == "carYear" && value == "בחר") {
      value = undefined;
    } else {
      switch (name) {
        case 'createDateFrom':
          // filter.createDateTo = value;
          break;
        case 'closeDateFrom':
          // filter.closeDateTo = value;
          break;
        case 'deliveryDateFrom':
          // filter.deliveryDateTo = value;
          break;
        case 'deliveryDateFrom':
          // filter.deliveryDateTo = value;
          break;
        default:
          break;
      }
    }
    filter[name] = value;
    // this.setState({filter: filter});
  }

  clearDate(dateName: string) {
    const filter = this.state.filter;
    switch (dateName) {
      case 'createDateFrom':
        this.setState({
          createDateFrom: undefined,
        });
        break;
      case 'createDateTo':
        this.setState({
          createDateTo: undefined,
        });
        break;
      case 'startDateMonth':
        filter.startDateMonth = undefined;
        this.setState({
          filter: filter,
        });
        break;
      case 'startDateYear':
        filter.startDateYear = undefined;
        this.setState({
          filter: filter,
        });
        break;
      default:
        break;
    }

    this.setStateDataAndFilter(dateName, null);
  }

  clearValue(name: string) {
    const filter = this.state.filter;
    filter[name] = '';
    switch (name) {
      case 'manufacturerId':
        this.setStateData("manufacturer", "");
        filter.vehicleModelId = undefined;
        filter.vehicleModel = '';
        filter.manufacturerId = undefined;
        filter.vehicleSubModelId = undefined;
        filter.vehicleSubModel = '';
        // this.filter(name, null);
        break;
      case 'vehicleModelId':
        this.setStateData("vehicleModel", "");
        const mList = this.state.vehicleSubModels
        this.setState({
          VehicleSubModelAll: mList,
          VehicleSubModelAutocomplete: mList
        });
        filter.vehicleSubModelId = undefined;
        filter.vehicleSubModel = '';

        if (filter.manufacturerId && filter.manufacturerId !== '') {
          this.onManufacturerSelect(filter.manufacturerId);
        }
        // this.filter(name, null);
        break;
      case 'vehicleSubModelId':
        this.setStateData("vehicleSubModel", '');
        const smList = this.state.vehicleSubModels
        this.setState({
          VehicleSubModelAll: smList,
          VehicleSubModelAutocomplete: smList
        });
        if (filter.vehicleSubModelId && filter.vehicleSubModelId !== '') {
          this.onSubModelSelect(filter.vehicleSubModelId);
        } else {
          if (filter.manufacturerId && filter.manufacturerId !== '') {
            this.onManufacturerSelect(filter.manufacturerId);
          }
        }
        break;
      case 'carYear':
        this.setStateData("vehicleSubModel", '');
        // this.filter(name, undefined);
        break;
      case 'salesUserId': {
        filter.salesUserId = undefined;
        filter.noHandler = undefined;
        this.setState({
          selectedSaleManName: undefined
        });
        break;
      }
      default:
        // selectedSaleManName
        // this.filter(name, null);
        break;
    }
    this.setState({ filter: filter });
    //console.log('filter', filter)
  }

  onManufacturerChange = (e: any) => {
    const search = e.target.value;
    this.setState({ manufacturer: search });
    // this.setStateData('manufacturer', search);
    const manufacturer: any = this.state.manufactures.find((e: any) => e.text === search);
    if (manufacturer) {
      // this.setState(manufacturerId: (manufacturer as any).value);
      this.setState({ manufacturer: (manufacturer as any).text });
      this.setFilter('manufacturerId', (manufacturer as any).value);
      // this.setFilter('manufacturer', (manufacturer as any).text);
      this.onManufacturerSelect((manufacturer as any).value);
    } else {
      const mList = this.state.vehicleModels
      this.setState({
        VehicleModelAutocomplete: mList,
        VehicleModelAll: mList
      });
    }
  }

  onManufacturerSelect = async (id: string) => {
    if (id) {
      const selectedManufacturer: any = this.state.manufactures.find((m: any) => m.value === id);
      // this.setStateData("manufacturer", selectedManufacturer.text);
      // this.setStateData("manufacturerId", selectedManufacturer.value);
      let data = await this.generalModel.getVehicleModels(id);
      const models = data.filter((i: any) => i.text !== null);


      data = await this.generalModel.getVehicleSubModelsByManufacturer(id);

      const subModelsList = data.filter((sm: any) => sm.label !== null && sm.label !== '').map((sm: any) => {
        let label = sm.label.trim();
        if (sm.code && sm.code !== '' && sm.code !== '0') {
          label = `[${sm.code}]${label}`;
        }
        return {
          code: sm.code,
          text: sm.label.trim(),
          label: label,
          value: sm.val
        }
      })

      // models.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1); 
      // // this.filter("manufacturerId", id);
      this.setState({
        VehicleModelAutocomplete: models,
        VehicleModelAll: models,
        VehicleSubModelAutocomplete: subModelsList
      });
    } else {
      // this.setStateData("manufacturer", null);
      // this.setStateData("manufacturer", "");
      // this.filter("manufacturerId", null);
      // this.filter("vehicleModelId", null);
      // this.filter("vehicleSubModelId", null);
      // this.setStateData("vehicleModel", "");
      // this.setStateData("vehicleModelId", "");
      // this.setStateData("vehicleSubModel", '');
      // this.setStateData("vehicleSubModelId", '');
      // this.setState({
      //     VehicleModelAll: [],
      //     VehicleModelAutocomplete: []
      // });
    }
  }

  onModelChange = (e: any) => {
    const search = e.target.value;
    //console.log('onModelChange', search, this.state.VehicleModelAll);
    this.setStateData('vehicleModel', search);
    const selectedModel: any = this.state.VehicleModelAll.find((m: any) => m.text === search);
    if (selectedModel) {
      this.onModelSelect(selectedModel.value);
      this.setFilter('vehicleModelId', selectedModel.value);
      //console.log('onModelChange', search, selectedModel);
    } else {
      this.setFilter('vehicleModelId', null);
    }
    const models = this.state.VehicleModelAll.filter(
      (m: any) => {
        return m.text != null && m.text.indexOf(search) > -1
      }
    );
    // this.setState({
    //     VehicleModelAutocomplete: models
    // });
  }

  onModelSelect = async (id: string) => {
    if (id) {
      const selectedModel: any = this.state.VehicleModelAll.find((m: any) => m.value === id);
      // this.setStateData("vehicleModel", selectedModel.text);
      // this.setStateData("vehicleModelId", selectedModel.value);
      var data = await this.generalModel.getVehicleSubModels(id);
      data.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);

      const subModelsList = data.map((sm: any) => {
        let label = sm.text.trim();
        if (sm.code && sm.code !== '' && sm.code !== '0') {
          label = `[${sm.code}]${label}`;
        }
        return {
          code: sm.code,
          text: sm.text.trim(),
          label: label,
          value: sm.value
        }
      })
      // //console.log('getVehicleSubModels', data);
      // this.filter("vehicleModelId", id);
      this.setState({
        VehicleSubModelAutocomplete: subModelsList
      });
    } else {
      this.setStateData("manufacturer", null);
      const smList = this.state.vehicleSubModels
      this.setState({
        VehicleSubModelAutocomplete: smList
      });
      this.setStateData("vehicleModel", "");
      // this.filter("vehicleModelId", null);
      // this.filter("vehicleSubModelId", null);
    }
  }

  findSubModelByText = (searchTxt: any) => {
    let selectedSubModel: any = this.state.VehicleSubModelAll.find((m: any) => m.label === searchTxt);
    if (selectedSubModel) {
      return selectedSubModel;
    } else return null;
  }
  onSubModelChange = (e: any) => {
    const search = e.target.value;
    this.setStateData('vehicleSubModel', search);
    // `${o.code ? `[${o.code}]`
    let selectedSubModel: any = this.findSubModelByText(search);
    // if (/^\d+$/.test(search) && search.length > 5) {
    //   selectedSubModel = this.state.VehicleSubModelAll.find((m: any) => m.code === search);
    // }
    if (selectedSubModel) {
      this.onSubModelSelect(selectedSubModel.value);
      // vehicleSubModelId
      this.setFilter('vehicleSubModelId', selectedSubModel.value);
    } else {
      this.setFilter('vehicleSubModelId', '');
    }
    const subModels = this.state.VehicleSubModelAll.filter(
      (m: any) => {
        return m.text != null && m.text.indexOf(search) > -1
      }
    );
  }


  onSubModelSelect = (id: string) => {
    if (id) {
      const selectedModel: any = this.state.VehicleSubModelAll.find((m: any) => m.value === id);
      this.setStateData("vehicleSubModel", selectedModel.text);
      this.setStateData("vehicleSubModelId", id);
      // this.filter("vehicleSubModelId", id);
    } else {
      this.setStateData("vehicleSubModel", '');
      this.setStateData("vehicleSubModelId", '');
      // this.filter("vehicleSubModelId", null);
    }
  }

  onSalesManSelect = (value: any) => {
    const search = value;
    this.setState({ selectedSaleManName: search });
    console.log('this.state.salesPeopleList', this.state.salesPeopleList)
    const selected = this.state.salesPeopleList.find((sp: any) => sp.label == search);
    console.log('selected', selected)
    if (selected) {
      // this.setState({ selectedSaleManName: selected.label });
      this.setStateData('salesUserId', selected.value);
    } else {
      // this.setState({ selectedSaleManName: undefined });
      this.setStateData('salesUserId', undefined);
    }
  }

  onRenewalManSelect = (value: any) => {
    const search = value;
    this.setState({ selectedRenewalManName: search });
    const selected = this.state.renewalHandlers.find((sp: any) => sp.label == search);
    console.log('selected', selected)
    if (selected) {
      // this.setState({ selectedSaleManName: selected.label });
      this.setState({ renewalUserId: selected.value });
      this.setState({ sendSalespersonAssignmentError: false });
    } else {
      // this.setState({ selectedSaleManName: undefined });
      this.setState({ renewalUserId: undefined });

    }
  }

  onClearRenewalManSelect = () => {
    this.setState({ renewalUserId: undefined });

  }

  onClearSalesManSelect = () => {
    this.clearValue('salesUserId')
  }

  onPolicyTypeChange(name: string, value: any) {
    this.setStateData(name, value);
    this.setStateData('leadType', '-1');

    // if (value === '-1') {
    //     value = undefined;
    // }
    // if (value !== '1') {
    //     this.setStateData('leadType', null);
    // }

    // this.filter(name, value);
  }

  onLeadTypeChange(name: string, value: any) {
    this.setStateData(name, value);
    if (value === '-1') {
      value = undefined;
    } else {
    }

    // this.filter(name, value);
  }

  onInsuranceCompanyChange(name: string, value: any) {
    this.setStateData(name, value);
    if (value === '-1') {
      value = undefined;
    } else {
    }

    // this.filter(name, value);
  }

  openAdvancedSearch() {
    this.setState({ advancedSearchOpen: true });
  }

  closeAdvancedSearch() {
    this.setState({ advancedSearchOpen: false });
  }

  editLead = (selectedId: string) => {
    // this.setState({IdForPopup: selectedId});
    if (this.state.data && this.state.data.leads) {
      const leads = this.state.data.leads;
      const leadData = leads.find(
        (lead: SPLeadModel) => lead.lead && lead.lead.id == selectedId
      )

      if (leadData && leadData.lead) {
        this.setState({
          selectedLead: leadData.lead,
          IdForPopup: selectedId
        });
      }

    }
  }

  viewLead= (selectedId: string) => {
    // this.setState({IdForPopup: selectedId});
    if (this.state.data && this.state.data.leads) {
      const leads = this.state.data.leads;
      const leadData = leads.find(
        (lead: SPLeadModel) => lead.lead && lead.lead.id == selectedId
      )

      if (leadData && leadData.lead) {
        this.setState({
          selectedLead: leadData.lead,
          IdForViewPopup: selectedId
        });
      }

    }
  }
  onGoToSimulatorClick = (selectedId: string) => {
    localStorage.setItem('lastLeadsFilter', JSON.stringify(this.state.filter));

  }
  openDeletePropmpt(selectedId: string) {
    this.setState({
      selectedLeadId: selectedId
    })
    this.openPromptPopUp('האם את/אתה בטוח/ה?', 'מחיקת ליד')
  }
  onDeleteLead = async (selectedId: string) => {
    await this.leadsModel.leadsDelete(selectedId);
    this.load(this.state.filter);
  }


  buildTreeSelectDataForBrunches = async () => {
    const allBranches = await this.simulatorModel.getBranchesAndUsers();
    // const rootItems = allBranches.filter((b: any) => b.parentId === null);
    // const branchesTree: any = [];

    const treeData: any[] = [];
    const treeDataForPopUp: any[] = [];
    // treeData.push(
    //   {
    //     value: '1',
    //     title: 'חדש',
    //     type: 'branchType'
    //   }
    // );
    // treeData.push(
    //   {
    //     value: '2',
    //     title: 'משומש',
    //     type: 'branchType'
    //   }
    // );
    // treeData.push(
    //   {
    //     value: '3',
    //     title: 'סלקט',
    //     type: 'branchType'
    //   }
    // );
    const bTree = await this.getBranchesTree(allBranches.branches);
    bTree.forEach((bItem: any) => {

      const branch: any = {
        title: bItem.name,
        value: bItem.id,
        type: 'branchId',
        selectable: true,
        children: this.buildTreeNodeBrunches(bItem.id, allBranches)
      }
      // const branchforPopUp: any = {
      //   title: bItem.name,
      //   value: bItem.id,
      //   type: 'branchId',
      //   selectable: false,
      //   children: this.buildTreeNode(bItem.id, allBranches, true)
      // }
      treeData.push(branch);
    })


    this.setState({ treeDataBrunches: treeData })
  }

  buildTreeSelectData = async () => {
    const allBranches = await this.simulatorModel.getBranchesAndUsers();
    // const rootItems = allBranches.filter((b: any) => b.parentId === null);
    // const branchesTree: any = [];

    const treeData: any[] = [];
    const treeDataForPopUp: any[] = [];
    treeData.push(
      {
        value: '1',
        title: 'חדש',
        type: 'branchType'
      }
    );
    treeData.push(
      {
        value: '2',
        title: 'משומש',
        type: 'branchType'
      }
    );
    treeData.push(
      {
        value: '3',
        title: 'סלקט',
        type: 'branchType'
      }
    );
    const bTree = await this.getBranchesTree(allBranches.branches);
    bTree.forEach((bItem: any) => {

      const branch: any = {
        title: bItem.name,
        value: bItem.id,
        type: 'branchId',
        children: this.buildTreeNode(bItem.id, allBranches)
      }
      const branchforPopUp: any = {
        title: bItem.name,
        value: bItem.id,
        type: 'branchId',
        selectable: false,
        children: this.buildTreeNode(bItem.id, allBranches, true)
      }

      const rootBranchManager = allBranches.users.find((u: any) => u.id === bItem.branchManagerId);
      if (rootBranchManager) {
        if (!branch.children) {
          branch.children = [];
        }
        branch.children.push({
          title: rootBranchManager.fullName,
          value: rootBranchManager.id,
          type: 'stationUserId',
        })
        if (!branchforPopUp.children) {
          branchforPopUp.children = [];
        }
        branchforPopUp.children.push({
          title: rootBranchManager.fullName,
          value: rootBranchManager.id,
          type: 'stationUserId',
        })
      }
      treeData.push(branch);
      treeDataForPopUp.push(branchforPopUp)
    });


    this.setState({
      treeData,
      treeDataForPopUp,
      allBranches: allBranches.branches,
      allUsers: allBranches.users
    });
  }

  buildTreeNode(id: string, allBranches: any, forPopUp: boolean = false) {
    const rootBranch = allBranches.branches.find((b: any) => b.id === id);
    const children = allBranches.branches.filter((b: any) => b.parentId === id);
    const nodeTree: any[] = []
    children.forEach((c: any) => {
      const branch: any = {
        title: c.name,
        value: c.id,
        selectable: !forPopUp,
        type: 'branchId',
        branchManagerId: c.branchManagerId
        // children: []
      }
      if (!branch.children) {
        branch.children = [];
      }
      branch.children = this.buildTreeNode(c.id, allBranches, forPopUp);
      if (c.users) {
        c.users.forEach((u: any) => {
          const user: any = {
            title: u.text,
            value: u.value,
            type: 'stationUserId',
          }
          branch.children.push(user);
        })
      }

      const branchUsers = allBranches.users.filter((u: any) => u.branchId === c.id);
      if (branchUsers && branchUsers.length > 0) {
        branchUsers.forEach((bUser: any) => {
          branch.children.push({
            title: bUser.fullName,
            value: bUser.id,
            type: 'stationUserId',
          })
        });
      }

      const branchManager = allBranches.users.find((u: any) => u.id === c.branchManagerId);
      if (branchManager) {
        if (!branch.children) {
          branch.children = [];
        }
        branch.children.push({
          title: branchManager.fullName,
          value: branchManager.id,
          type: 'stationUserId',
        })
      }
      nodeTree.push(branch);
    })
    return nodeTree;
  }

  buildTreeNodeBrunches(id: string, allBranches: any, forPopUp: boolean = false) {
    const rootBranch = allBranches.branches.find((b: any) => b.id === id);
    const children = allBranches.branches.filter((b: any) => b.parentId === id);
    const nodeTree: any[] = []
    children.forEach((c: any) => {
      const branch: any = {
        title: c.name,
        value: c.id,
        selectable: true,
        type: 'branchId',
        branchManagerId: c.branchManagerId
        // children: []
      }
      if (!branch.children) {
        branch.children = [];
      }
      branch.children = this.buildTreeNodeBrunches(c.id, allBranches, forPopUp);
      if (c.users) {
        c.users.forEach((u: any) => {
          const user: any = {
            title: u.text,
            value: u.value,
            type: 'stationUserId',
          }
          branch.children.push(user);
        })
      } else if (branch['children'].length == 0) {
        delete branch['children'];
      }
      nodeTree.push(branch);
    })
    return nodeTree;
  }


  async getBranchesTree(allBranches: any[]) {
    // const allBranches = await this.simulatorModel.getBranches();
    if (!allBranches || allBranches.length == 0) return [];
    const branchesTree = allBranches.filter((b: any) => b.parentId === null);
    // //console.log('branchesTree', branchesTree);
    branchesTree.forEach((rootBranch: any) => {
      rootBranch.children = this.getSubBranches(rootBranch, allBranches);
    });
    return branchesTree;
  }

  getSubBranches = (branch: any, branches: any[]) => {
    const subBranches = branches.filter((b: any) => b.parentId === branch.id);

    if (subBranches && subBranches.length > 0) {
      subBranches.forEach((b: any) => {
        b.children = this.getSubBranches(b, branches);
      })
    }
    return subBranches;
  }


  sortLeadsBy = (name: string) => {
    let allLeads: SPLeadModel[] = [];
    let sortLeedsBy: any = this.state.sortLeedsBy ? this.state.sortLeedsBy : {
      name: '',
      direction: 'ASC'
    };
    const filter = this.state.filter;
    if (sortLeedsBy.name == name && sortLeedsBy.direction == 'DESC') {
      filter.SortBy = undefined;
      sortLeedsBy = null;
    } else {
      allLeads = this.state.leadsList;
      if (sortLeedsBy.name != name) {
        sortLeedsBy.name = name;
        sortLeedsBy.direction = 'ASC';
      } else {
        if (sortLeedsBy.direction == 'DESC') {
          sortLeedsBy.direction = 'ASC';
        } else {
          sortLeedsBy.direction = 'DESC';
        }
      }

      filter.SortBy = [{
        Property: sortLeedsBy.name,
        SortDirection: sortLeedsBy.direction == 'ASC' ? 0 : 1
      }]


    }
    this.setState({
      filter: filter,
      sortLeedsBy: sortLeedsBy
    });

    this.load(filter)

  }

  onSelect(value: any, node: any) {
  };

  async onChange(newValue: string, label: any, extra: any) {
    var filter = this.state.filter;
    switch (newValue) {
      case '1':
      case '2':
      case '3':
        filter['BranchType'] = newValue;
        filter['BranchId'] = undefined;
        filter['stationUserId'] = undefined;
        break;

      default:
        const branch = this.state.allBranches.find((b: any) => b.id === newValue);
        if (branch) {
          filter['BranchId'] = newValue;
          filter['BranchType'] = undefined;
          filter['stationUserId'] = undefined;
        } else {
          filter['stationUserId'] = newValue;
          filter['BranchId'] = undefined;
          filter['BranchType'] = undefined;
        }
        break;
    }

    const treeDataValue = label[0] ? label[0] : '';
    localStorage.setItem('lastTreeDataValue', treeDataValue)
    await this.setState({
      filter: filter,
      treeDataValue
    });
    this.filter();
  };

  openPopupMessage(data: any) {
    //console.log('messageContent', data.response);
    if (data && data.response && typeof data.response !== 'undefined') {
      this.setState({ messageContent: data.response });
    }
  }

  onLoggedUserChange(status: boolean) {
    this.setState({ userLogged: status });
  }


  closeRiderPopup() {
    this.setState({ riderForRenewPopup: undefined });
  }

  emptyFunc() { }
  // closeProduction = () => {

  //   this.setState({offerIdData: null});


  // }

  closeShowExport = () => {
    this.setState({ showExport: false });
  }

  showExportModel = () => {
    this.setState({ showExport: true });
  }

  showNumericalMarking = () => {
    this.setState({ numericalMarking: true });
  }

  closeNumericalMarking = () => {
    this.setState({ numericalMarking: false });
  }

  setLeadtreatmentOff = () => {
    this.props.setLeadTreatmentPopUp(false);
    this.props.setLeadIdForTreatment("");
    this.props.setLeadTreatmentType(0);
  }

  setRiderForRenewPopup(rider: RiderModel) {
    this.setState({ riderForRenewPopup: rider });
  }

  render() {

    var lead = this.state.leadsList && this.state.leadsList.length > 0 && this.state.leadsList.find((lead: any) => lead && lead.lead && lead.lead.id == this.props.leadId)
    var offer = lead && lead.lead && lead.lead.offers && lead.lead.offers.find((offer) => offer.id == this.props.offerIdData)
    const renderedCustomerIds = new Set();

    return (
      <div className="App">
        {this.state.riderForRenewPopup ?
          <SubscriberPopup
            id={this.state.riderForRenewPopup.id}
            actionType={undefined}
            rider={this.state.riderForRenewPopup}
            ClosePopup={() => this.closeRiderPopup()}
            OpenPayment={() => this.emptyFunc()}
            setPopupShow={undefined}
            setMessege={undefined}
            renewRider={true}
            customer={this.state.riderForRenewPopup.customer}
            vehicle={this.state.riderForRenewPopup.vehicle}
            setMessageType={undefined}
          />
          : ""}




        {this.state.isShowRenewalsConfigPopup ? <RenewalsConfigPopup ClosePopup={this.closeShowRenewalsConfigPopup} OnApprove={this.closeShowRenewalsConfigPopup} messageTitle="הגדרות חידושים"></RenewalsConfigPopup> : ""}

        <SalespersonAssignment></SalespersonAssignment>

        {
          this.state.IdForPopup != null ?
            (
              <RenewalUpdatePrice
                id={this.state.IdForPopup}
                ClosePopup={this.closeNewLead}
              />
            ) : ""
        }

        {
          this.state.IdForViewPopup != null && <RenewalOfferPopup
                renewalId={this.state.IdForViewPopup}
                closePopup={this.closeViewPopup}
              />
           
        }

        

        {this.state.showPopupModel && (
          <ClientPopup
            messageContent={this.state.popUpContent}
            messageTitle={this.state.popUptitle}
            ShowHidePopup={() => this.showHidePopup()}
            ClosePopup={() => this.showHidePopup()}
          />
        )}

        {
          this.state.leadDocumentUrl != null ?
            (
              <LeadDocumentPopup
                ClosePopup={this.closeDocumentPopup}
                documentUrl={this.state.leadDocumentUrl}
              />
            ) : ""
        }
        {
          this.state.messageContent != null && this.state.messageContent != '' ?
            (
              <LeadMessagePopup
                ClosePopup={() => this.closeMessagePopup()}
                messageContent={this.state.messageContent}
              />
            ) : ""
        }
        {
          this.state.promptContent != null && this.state.promptContent != '' ?
            (
              <LeadMessagePopup
                ClosePopup={() => this.closePromptPopup()}
                OnApprove={() => this.onPromptApprove()}
                approveBtnTitle={'מחק'}
                messageContent={this.state.promptContent}
                messageTitle={this.state.promptTitle}
              />
            ) : ""
        }
        {this.state.showExport && this.state.treeDataBrunches && this.state.agentsList && this.state.salesPeopleList &&
          <ExportExcelPopUp
            treeDataBrunches={this.state.treeDataBrunches}
            allBranches={this.state.allBranches}
            allUsers={this.state.allUsers}
            saveState={this.state.dataLoaded}
            ClosePopup={() => this.closeShowExport()}
            leadsFilter={this.state.filter}
            searchStatuses={this.state.searchStatuses}
            LeadTopType={this.state.LeadTopType}
            LeadTypes={this.state.LeadTypes}
            manufacturesList={this.state.manufacturesList}
            manufactures={this.state.manufactures}
            vehicleModels={this.state.vehicleModels}
            VehicleSubModelAll={this.state.VehicleSubModelAll}
            agentsList={this.state.agentsList}
            salesPeopleListOrigin={this.state.salesPeopleListOrigin}
          />
        }

        {this.state.numericalMarking ?
          <NumericalMarkingPopup
            closePopup={() => this.closeNumericalMarking()}
            agentsList={this.state.allUsers}
            renewalsCount={this.state.pagerConf.totalItems}
            filter={this.state.filter}
          />:""
        }

        {
          this.props.leadTreatmentPopUp ?
            <ClientAddTreatmentPopup
              // messageTitle={newTreatmentType.toString()}
              type={this.props.leadTreatmentType}
              ClosePopup={this.setLeadtreatmentOff}
              customerId={this.props.leadIdForTreatment ? this.props.leadIdForTreatment : ''}
              showPopUpMessage={(content: string) => this.openMessagePopUp(content)}
            /> : " "
        }

        {
          this.props.documentLeadTaskUrl.length > 0 && (
            <TaskDocumentPopup
              ClosePopup={() => this.onHideDocumentPopUp()}
              documentUrl={this.props.documentLeadTaskUrl}
            />
          )
        }

        {
          this.state ? (
            <div className='main-content rtl'>
              <Menu activePage='Renewals' />
              <div className='center-content'>
                <Header PageName="חידושים" />
                <div className='lleads'>
                  <section className="main-body">
                    <div className="content-header">
                      <div className="flex-centered flex-space-between  mobile-only">
                        <div className="content-main-title">לידים</div>
                        <div className="actions flex-centered flex-space-between">
                          <div className="icon search"></div>
                          <div className="icon sort"></div>
                          <div className="icon add"></div>
                        </div>
                      </div>
                      <div className="flex-end desktop-only">
                        <div className="list-actions-row flex-centered flex-space-between">
                          <div>
                            <div className="filter-row-leads filter-row flex-centered flex-start flex-top">
                              <div className="filter-input search">
                                <input type="text"
                                  value={this.state.searchText ? this.state.searchText : ''}
                                  onChange={(e: any) => this.handleSearchChange("searchText", e)}
                                  placeholder="חיפוש" />
                                <div className={`icon x-clear pointer ${!this.state.filter.searchText || this.state.filter.searchText == '' ? 'hide' : ''}`} onClick={() => this.clearFilterValue('searchText')}></div>
                                <div className="icon search"></div>
                              </div>
                            </div>
                            <div className="filter-row-leads filter-row flex-centered flex-start flex-top">
                              <div>
                                <div className="filter-input startDateMonth">
                                  <Select
                                    options={this.monthOptions}
                                    value={this.monthOptions.find(o => o.value === this.state.filter.startDateMonth) || null}
                                    onChange={(newValue: SingleValue<Option>) => this.setStateData("startDateMonth", newValue)}
                                    placeholder="בחר חודש חידוש"
                                  />
                                  <div className={`icon x-clear pointer ${!this.state.filter.startDateMonth ? 'hide' : ''}`} onClick={() => this.clearDate('startDateMonth')}></div>
                                  {/* <CompDatePicker placeholder={'מתאריך פתיחה'} value={this.state.filter.createDateFrom} onChange={(date: Date) => this.setStateData("createDateFrom", date)} />
                                  <div className={`icon x-clear pointer ${!this.state.filter.createDateFrom ? 'hide' : ''}`} onClick={() => this.clearDate('createDateFrom')}></div> */}
                                </div>
                                <div className="filter-input">
                                  <IDNameDescriptionItemSelect
                                    OnChange={(name: string, value: any) => this.onInsuranceCompanyChange(name, value)}
                                    Id={"insuranceCompanyId"}
                                    Value={this.state.filter.insuranceCompanyId ? this.state.filter.insuranceCompanyId : '-1'}
                                    Options={this.state.InsuranceCompanies}
                                  //Disabled={this.state.filter.policyType !== '1'}
                                  />
                                </div>
                                


                                {/* <div className="filter-input closeDateFrom">
                                  <CompDatePicker placeholder={'מתאריך סגירה '} value={this.state.filter.closeDateFrom} onChange={(date: Date) => this.setStateData("closeDateFrom", date)} />
                                  <div className={`icon x-clear pointer ${!this.state.filter.closeDateFrom ? 'hide' : ''}`} onClick={() => this.clearDate('closeDateFrom')}></div>
                                </div> */}
                                {/* <div className="filter-input deliveryDateFrom">
                                  <CompDatePicker placeholder={'מתאריך הצעה/חידוש'} value={this.state.filter.deliveryDateFrom} onChange={(date: Date) => this.setStateData("deliveryDateFrom", date)} />
                                  <div className={`icon x-clear pointer ${!this.state.filter.deliveryDateFrom ? 'hide' : ''}`} onClick={() => this.clearDate('deliveryDateFrom')}></div>
                                </div> */}
                              </div>
                              <div>
                                <div className="filter-input startDateYear">
                                  {/* <CompDatePicker placeholder={'עד תאריך פתיחה'} value={this.state.filter.createDateTo} onChange={(date: Date) => this.setStateData("createDateTo", date)} />*/}



                                  <Select
                                    options={this.yearsOptions}
                                    value={this.yearsOptions.find(o => o.value === this.state.filter.startDateYear) || null}
                                    onChange={(newValue: SingleValue<Option>) => this.setStateData("startDateYear", newValue)}
                                    placeholder="בחר שנת חידוש"
                                  />
                                  <div className={`icon x-clear pointer ${!this.state.filter.startDateYear ? 'hide' : ''}`} onClick={() => this.clearDate('startDateYear')}></div>
                                </div>
                                {/* <div className="filter-input closeDateTo">
                                  <CompDatePicker placeholder={'עד תאריך סגירה '} value={this.state.filter.closeDateTo} onChange={(date: Date) => this.setStateData("closeDateTo", date)} />
                                  <div className={`icon x-clear pointer ${!this.state.filter.closeDateTo ? 'hide' : ''}`} onClick={() => this.clearDate('closeDateTo')}></div>
                                </div> */}
                                {/* <div className="filter-input deliveryDateTo">
                                  <CompDatePicker placeholder={'עד תאריך הצעה/חידוש'} value={this.state.filter.deliveryDateTo} onChange={(date: Date) => this.setStateData("deliveryDateTo", date)} />
                                  <div className={`icon x-clear pointer ${!this.state.filter.deliveryDateTo ? 'hide' : ''}`} onClick={() => this.clearDate('deliveryDateTo')}></div>
                                </div> */}
                              </div>
                              <div>
                                <StationUserSelect data={{
                                  branches: this.state.allBranches,
                                  users: this.state.allUsers,
                                  clearFilter: this.state.clearFilter,
                                  saveState: this.state.dataLoaded
                                }} onChange={(data: any) => this.onStationUserChange(data)} />
                              </div>



                              <div>

                                <div className="filter-input">
                                  {this.state.searchStatuses ?
                                    (
                                      <>
                                        <Select
                                          style={{ width: '100%' }}
                                          defaultValue={this.state.selectedStatus}
                                          value={this.state.selectedStatus}
                                          onChange={this.onStatusChange2}
                                          options={
                                            Object.keys(this.state.searchStatuses).map((k: string) => {
                                              const option = this.state.searchStatuses[k];
                                              return {
                                                label: option.name,
                                                value: option.id
                                              };
                                            })
                                          }
                                        />
                                      </>
                                    ) : ""
                                  }
                                </div>
                                <div className="filter-input">
                                  <IDNameDescriptionItemSelect
                                    OnChange={(name: string, value: any) => this.onPolicyTypeChange(name, value)}
                                    Id={"policyType"}
                                    Value={this.state.filter.policyType ? this.state.filter.policyType : '0'}
                                    Options={this.state.LeadTopType}
                                  />

                                </div>
                                {/* <div className="filter-input">
                                  <IDNameDescriptionItemSelect
                                    OnChange={(name: string, value: any) => this.onLeadTypeChange(name, value)}
                                    Id={"leadType"}
                                    Value={this.state.filter.leadType ? this.state.filter.leadType : '-1'}
                                    Options={this.state.LeadTypes}
                                    Disabled={this.state.filter.policyType !== '1'}
                                  />
                                </div>
                                */}
                                <div className="filter-input">
                                  <IDNameDescriptionItemSelect
                                    OnChange={(name: string, value: any) => this.onPolicyTypeChange(name, value)}
                                    Id={"insuranceType"}
                                    Value={this.state.filter.insuranceType ? this.state.filter.insuranceType : ''}
                                    Options={this.state.VehicleInsuranceTypes}
                                  />
                                </div>
                              </div>
                              <div>
                                <div className="filter-input">
                                  {this.state ? <>
                                    <input type='text'
                                      list="manufacturer_list"
                                      placeholder='יצרן'
                                      onChange={(e: any) => this.onManufacturerChange(e)}
                                      value={this.state.manufacturer ? this.state.manufacturer : ''}
                                    />
                                    <datalist id="manufacturer_list">
                                      {this.state.manufacturesList.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                    </datalist>
                                    <div className={`icon x-clear pointer ${this.state.manufacturer == '' ? 'hide' : ''}`} onClick={() => this.clearFilterValue('manufacturerId')}></div>
                                  </> : <></>}
                                </div>
                                <div className="filter-input">
                                  <input type='text'
                                    list="model_list"
                                    placeholder='דגם'
                                    onChange={(e: any) => this.onModelChange(e)}
                                    value={this.state.filter && this.state.filter.vehicleModel ? this.state.filter.vehicleModel : ""}
                                  />
                                  <datalist id="model_list">
                                    {this.state.VehicleModelAutocomplete && this.state.VehicleModelAutocomplete.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                  </datalist>
                                  <div className={`icon x-clear pointer ${!this.state.filter.vehicleModel ? 'hide' : ''}`} onClick={() => this.clearValue('vehicleModelId')}></div>
                                </div>
                                <div className="filter-input">
                                  <input type='text'
                                    placeholder='קוד דגם'
                                    list="submodel_list"
                                    onChange={(e: any) => this.onSubModelChange(e)}
                                    value={this.state.filter && this.state.filter.vehicleSubModel ? this.state.filter.vehicleSubModel : ""}
                                  />
                                  <datalist id="submodel_list">
                                    {this.state.VehicleSubModelAutocomplete && this.state.VehicleSubModelAutocomplete.map((o: any, i) => <option key={i} value={o.label}>{o.label}</option>)}
                                  </datalist>
                                  <div className={`icon x-clear pointer ${!this.state.filter.vehicleSubModel || this.state.filter.vehicleSubModel == '' ? 'hide' : ''}`} onClick={() => this.clearValue('vehicleSubModelId')}></div>
                                </div>
                              </div>
                              <div>
                                <div className="filter-input">
                                  <Select
                                    style={{ width: '100%' }}
                                    defaultValue={this.state.filter.carYear && this.state.filter.carYear !== '' ? this.state.filter.carYear : 'שנת יצור'}
                                    value={this.state.selectedCarYear}
                                    onChange={this.onCarYearChange}
                                    options={
                                      this.state.carYears.map((year: string) => {
                                        return {
                                          label: year,
                                          value: year
                                        }
                                      })
                                    }
                                  />
                                </div>


                                <div className="filter-input">
                                  <Select
                                    style={{ width: '100%' }}
                                    // defaultValue={this.state.filter.agentId && this.state.filter.agentId !== '' ? this.state.filter.agentId : 'סוכן'}
                                    value={this.state.filter.agentId && this.state.filter.agentId !== '' ? this.state.filter.agentId : 'סוכן'}
                                    onChange={this.onAgentChange}
                                    options={
                                      [
                                        {
                                          label: 'סוכן',
                                          value: ""
                                        },
                                        ...this.state.agentsList.map((agent: any) => {
                                          return {
                                            label: agent.name,
                                            value: agent.id
                                          }
                                        })
                                      ]
                                    }
                                  />
                                </div>
                                <div className="filter-input">




                                  <CustomSearchHandler
                                    salesPeopleList={this.state.salesPeopleList}
                                    onSalesManSelect={(value: any) => this.onSalesManSelect(value)}
                                    selectedSaleManName={this.state.selectedSaleManName}
                                    clearValue={() => this.onClearSalesManSelect()}
                                  />

                                </div>
                              </div>

                              <div>
                                <div className="filter-button">
                                  <button className="act-btn" onClick={(e: any) => this.filter()}>הצג דוח</button>
                                </div>
                                <div className="filter-button">
                                  <button className="act-btn" onClick={(e: any) => this.clearFilterAll()}>נקה בחירה</button>
                                </div>
                                {this.state.isAdmin &&
                                  <div>
                                    <button className='act-btn' onClick={(e: any) => this.showExportModel()}>יצוא לאקסל</button>
                                  </div>
                                }
                              </div>

                            </div>
                          </div>

                          {this.state.isAdmin ?
                            <div>
                              {/* <button type="button" onClick={(e: any) => this.renewalImport()} className="button blue has-icon flex-centered flex-justify-center">
                                <div className="icon add"></div>
                                יבוא חידושים
                              </button> */}
                              <div className="icon icon-config gear pointer" onClick={(e: any) => this.showRenewalsConfigPopup()}></div>
                              {!this.state.isSalespersonAssignment ?
                                <>
                                  <div>
                                    <div className="filter-input ">
                                      <CustomSearchHandler
                                        salesPeopleList={this.state.renewalHandlers}//{this.state.renewalHandlers}
                                        onSalesManSelect={(value: any) => this.onRenewalManSelect(value)}
                                        selectedSaleManName={this.state.selectedRenewalManName}
                                        clearValue={() => this.onClearRenewalManSelect()}
                                      />

                                    </div>
                                    {this.state.sendSalespersonAssignmentError ? <div className=' error-message'>*שדה חובה</div> : ""}
                                  </div>
                                  <div className='CustomSearchHandlerSpace'>
                                    <button type="button" onClick={(e: any) => this.sendSalespersonAssignment()} className="button blue has-icon flex-centered flex-justify-center">
                                      שייך                              </button>
                                    {/* <button type="button" onClick={(e: any) => this.sendSalespersonAssignmentAllFilter()} className="button blue has-icon flex-centered flex-justify-center">
                                    שייך את כל הסינון                              </button> */}
                                    {/* <button type="button" onClick={(e: any) => this.sendSalespersonAssignmentByLetters()} className="button blue has-icon flex-centered flex-justify-center">
                                      שייך לפי אותיות                              </button> */}
                                    <button type="button" onClick={(e: any) => this.salespersonAssignment()} className="button blue has-icon flex-centered flex-justify-center">
                                      ביטול                              </button></div>

                                </>


                                :
                                <>
                                  <button type="button" onClick={(e: any) => this.salespersonAssignment()} className="button blue has-icon flex-centered flex-justify-center">
                                    שיוך לאיש מכירות
                                  </button>
                                  <button type="button" onClick={(e: any) => this.showNumericalMarking()} className="button blue has-icon flex-centered flex-justify-center">
                                    בחירת סימון מספרי
                                  </button>
                                </>
                              }
                            </div>
                            : <></>}
                        </div>

                        {this.state.ShowAllDataMessage ?
                          <>
                            {this.state.byFilter ?
                              <div className="allDataMessage" onClick={(e: any) => this.clearByFilter()}><span>כל ה<b>{this.state.pagerConf.totalItems}</b> החידושים נבחרו.</span> <a id=":2wh" className="x8" role="link" >לניקוי הבחירה</a></div> :
                              <div className="allDataMessage" onClick={(e: any) => this.sendSalespersonAssignmentAllFilter()}><span>כל ה<b>{this.state.pagerConf.pageSize}</b> החידושים נבחרו.</span> <a id=":2wh" className="x8" role="link" >בחירת כל <b>{this.state.pagerConf.totalItems}</b> החידושים</a></div>}
                          </>
                          : ""}



                        {this.state.data ? (<div className="content-table-header leads-list-header flex-centered flex-space-between">
                          <div className={this.state.isSalespersonAssignment ? "hide" : "cell icon-cell pointer"} >
                            <div className={this.isAllRenewalsChecked() ? "hide" : ""} onClick={() => this.checkAllRenewals()}>בחר הכל</div>
                            <div className={this.isAllRenewalsChecked() ? "" : "hide"} onClick={() => this.uncheckAllRenewals()}>נקה הכל</div>
                          </div>
                          <div className="cell icon-cell pointer" onClick={() => this.sortLeadsBy('hasOffers')}>
                            <FontAwesomeIcon icon={faHammer} />
                          </div>
                          {/* <div className="cell status  flex-centered flex-space-between">
                                          סטטוס
                                          <div className="icon sort"></div>
                                      </div> */}
                          <div className="cell status pointer" onClick={() => this.sortLeadsBy('lastStatusName')}>
                            סטטוס
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'lastStatusName' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" onClick={() => this.sortLeadsBy('FullName2')}>
                            איש קשר
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'FullName2' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" onClick={() => this.sortLeadsBy('HanlerName')}>
                            איש מכירות
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'HanlerName' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" onClick={() => this.sortLeadsBy('Identifier')}>
                            ת.ז.
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'Identifier' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" onClick={() => this.sortLeadsBy('PhoneNumber1')}>
                            טלפון
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'PhoneNumber1' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('LicenseNumber')}>
                            נכס
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'LicenseNumber' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('PolicyNumber')}>
                            מס פוליסה
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'PolicyNumber' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('policyName')}>
                            סוג פוליסה
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'policyName' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('VehiclePolicyType')}>
                            סוג ביטוח
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'VehiclePolicyType' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('InsuranceCompany')}>
                            חברה
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'InsuranceCompany' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell car-details pointer" onClick={() => this.sortLeadsBy('r.RouteId')}>
                            ענף
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'r.RouteId' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" onClick={() => this.sortLeadsBy('PolicyEndDate')}>
                            ת. סיום
                            <div className={`icon sort ${this.state.sortLeedsBy && this.state.sortLeedsBy.name == 'PolicyEndDate' ? this.state.sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                              }`}></div>
                          </div>
                          <div className="cell pointer" >

                          </div>


                          <div className="cell button-cell"></div>
                          {/* <div className="cell action"></div> */}
                        </div>
                        ) : ""}

                      </div>
                    </div>

                    {
                      this.state.leadsList && this.props.offerIdData != null && offer &&
                      <LeadOfferProduction
                        offer={offer}
                        onGoToSimulatorClick={(e: string) => this.onGoToSimulatorClick(e)}
                        onEdit={(e: any) => this.editLead(e)}
                      />
                    }



                    {this.state && this.state.leadsList && this.state.leadsList.length > 0 ? (
                      <div className="content-body leads-list">

                        {

                          this.state.leadsList.length > 0 ? this.state.leadsList.map((lead: SPLeadModel, index: number) => {
                            const leadId = lead && lead.lead ? lead.lead.id : '';
                            const customerId = lead.lead && lead.lead && lead.lead.customer && lead.lead.customer.id ? lead.lead.customer.id : '';
                            const isOpened = this.state.openedLeadId == leadId
                            //console.log('isOpened', leadId, this.state, isOpened)
                            var riders = this.state.ridersList;
                            let riderComponent = null;
                            if (
                              customerId &&
                              !renderedCustomerIds.has(customerId) &&
                              this.state.ridersList.some(item => item.customer && item.customer.id === customerId)
                            ) {
                              var rider = this.state.ridersList.find(item => item.customerId === customerId);

                              renderedCustomerIds.add(customerId);
                              riderComponent = (
                                <RiderRenewal
                                  rider={rider}
                                  lead={lead}
                                  isSalespersonAssignment={this.state.isSalespersonAssignment}
                                  checked={lead.checked}
                                  getAuthorizedToDriveName={this.getAuthorizedToDriveName}
                                  onEdit={(e: any) => this.editLead(e)}
                                  onDelete={(e: any) => this.openDeletePropmpt(e)}
                                  isAdmin={this.state.isAdmin}
                                  opened={isOpened}
                                  openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                  openDocumentPopup={(u: string) => this.openDocumentPopup(u)}
                                  updateLeadStatus={(v: string, s: string) => this.updateLeadStatus(v, s)}
                                  leadStatuses={this.state.leadStatuses}
                                  onGoToSimulatorClick={this.onGoToSimulatorClick}
                                  onCallStart={() => { }}
                                  key={index}
                                  checkPermissionsOfCreator={() => this.checkPermissionsOfCreator()}
                                  checkPermissionsOfEdit={() => this.checkPermissionsOfEdit()}
                                  onCheckRenewal={(d: string, isShift: boolean) => this.onCheckRenewal(d, isShift)}
                                  setRiderForRenewPopup={(r: RiderModel) => this.setRiderForRenewPopup(r)}
                                />
                              );
                            }


                            return (
                              <>
                                <Renewal
                                  lead={lead}
                                  isSalespersonAssignment={this.state.isSalespersonAssignment}
                                  checked={lead.checked}
                                  getAuthorizedToDriveName={this.getAuthorizedToDriveName}
                                  onEdit={(e: any) => this.editLead(e)}
                                  onView={(e: any) => this.viewLead(e)}
                                  onDelete={(e: any) => this.openDeletePropmpt(e)}
                                  isAdmin={this.state.isAdmin}
                                  opened={isOpened}
                                  openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                  openDocumentPopup={(u: string) => this.openDocumentPopup(u)}
                                  updateLeadStatus={(v: string, s: string) => this.updateLeadStatus(v, s)}
                                  leadStatuses={this.state.leadStatuses}
                                  onGoToSimulatorClick={this.onGoToSimulatorClick}
                                  onCallStart={() => { }}
                                  key={index}
                                  checkPermissionsOfCreator={() => this.checkPermissionsOfCreator()}
                                  checkPermissionsOfEdit={() => this.checkPermissionsOfEdit()}
                                  onCheckRenewal={(d: string, isShift: boolean) => this.onCheckRenewal(d, isShift)}
                                ></Renewal>
                                {riderComponent ? riderComponent : ""}
                              </>
                            )


                          }) : ""}

                      </div>
                    ) : ""}

                    {this.state.filter.policyType == 24 ?/*rider*/
                      <div className="content-body leads-list">
                        {this.state.ridersList.length > 0 ? this.state.ridersList.map((rider: SPLeadModel, index: number) => {
                          return (<RiderRenewal
                            rider={rider}
                            lead={null}
                            isSalespersonAssignment={this.state.isSalespersonAssignment}
                            checked={undefined}
                            getAuthorizedToDriveName={this.getAuthorizedToDriveName}
                            onEdit={(e: any) => this.editLead(e)}
                            onDelete={(e: any) => this.openDeletePropmpt(e)}
                            isAdmin={this.state.isAdmin}
                            opened={false}
                            openPopupMessage={(d: any) => this.openPopupMessage(d)}
                            openDocumentPopup={(u: string) => this.openDocumentPopup(u)}
                            updateLeadStatus={(v: string, s: string) => this.updateLeadStatus(v, s)}
                            leadStatuses={this.state.leadStatuses}
                            onGoToSimulatorClick={this.onGoToSimulatorClick}
                            onCallStart={() => { }}
                            key={index}
                            checkPermissionsOfCreator={() => this.checkPermissionsOfCreator()}
                            checkPermissionsOfEdit={() => this.checkPermissionsOfEdit()}
                            onCheckRenewal={(d: string, isShift: boolean) => this.onCheckRenewal(d, isShift)}
                            setRiderForRenewPopup={(r: RiderModel) => this.setRiderForRenewPopup(r)}
                          />);

                        }) : this.state.leadsList.length + ""}
                      </div>
                      : this.state.filter.policyType}



                  </section>

                  {/* <Footer AllRowsCounter={this.state.data!=null && this.state.data.allRowsCounter!=null?this.state.data.allRowsCounter:0} rowsInPage={50} currentPage={1} /> */}

                  <footer className="footer emails-list-footer emails-list-view">
                    <Pagger pagerConf={this.state.pagerConf} changePage={(e: any) => this.onChangePage(e)}></Pagger>
                  </footer>

                </div>
              </div>
              {
                this.state.loading && (
                  <PleaseWaitLayer />
                )
              }
              <LoginStatus onChange={(status: boolean) => this.onLoggedUserChange(status)} />
              {this.state.notLogged && <GoToLogin />}
              {
                !this.state.userLogged && <LoginPopup />
              }
            </div >

          ) : (
            ''
          )
        }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setIdForLeadPopup: (id: string | null) => dispatch(setIdForLeadPopup(id)),
    setBranchesData: (data: any) => dispatch(setBranchesData(data)),
    dispatch,
    setLeadTreatmentPopUp: (data: boolean) => dispatch(setLeadTreatmentPopUp(data)),
    setLeadIdForTreatment: (data: string) => dispatch(setLeadIdForTreatment(data)),
    setLeadTreatmentType: (data: number) => dispatch(setLeadTreatmentType(data)),
    setDocumentLeadTaskUrl: (url: any[]) => dispatch(setDocumentLeadTaskUrl(url)),
    setLeadsData: (data: any) => dispatch(setLeadsData(data)),
    setRedirectToLeads: (data: boolean) => dispatch(setRedirectToLeads(data)),
  }
}

const mapStateToProps = (state: RootState) => ({
  idForLeadPopup: state.policyProduction.idForLeadPopup,
  offerIdData: state.policyProduction.offerId,
  leadId: state.policyProduction.leadId,
  leadTreatmentPopUp: state.leads.leadTreatmentPopUp,
  leadTreatmentType: state.leads.leadTreatmentType,
  leadIdForTreatment: state.leads.leadIdForTreatment,
  documentLeadTaskUrl: state.leads.documentLeadTaskUrl,
  leadsData: state.leads.leadsData,
  redirectToLeads: state.leads.redirectToLeads,
});

export default connect(mapStateToProps, mapDispatchToProps)(Renewals);

